import { useLayoutEffect } from 'react';

import type { ContentTypeBridgeAPI } from '@confluence/content-types-bridge/entry-points/content-types-shell-types.ts';
import type { NotifyCanvasFlagToShareProgress } from '@confluence/experiment-twcg-2055-flag-to-share/entry-points/useCanvasFlagToShare.ts';

type UseRegisterShareCriteriaProgressOptions = {
	bridge: ContentTypeBridgeAPI;
	shouldCollectProgress: boolean;
	notifyProgress: NotifyCanvasFlagToShareProgress;
};

/** Dynamically exposes the active share-criteria notifier without replacing the bridge. */
export const useRegisterShareCriteriaProgress = ({
	bridge,
	shouldCollectProgress,
	notifyProgress,
}: UseRegisterShareCriteriaProgressOptions): void => {
	useLayoutEffect(() => {
		if (!shouldCollectProgress || !bridge.confluenceAPI) {
			return;
		}

		const onboarding = bridge.confluenceAPI.onboarding ?? {};
		bridge.confluenceAPI.onboarding = onboarding;
		onboarding.notifyShareCriteriaProgress = notifyProgress;

		return () => {
			if (onboarding.notifyShareCriteriaProgress === notifyProgress) {
				delete onboarding.notifyShareCriteriaProgress;
			}
		};
	}, [bridge, notifyProgress, shouldCollectProgress]);
};
